/**
 * Auth route guards.
 * These wrap protected routes and redirect unauthenticated users.
 */

import { Navigate, useLocation } from 'react-router-dom';

import { useAuth } from '@/auth/AuthContext';

interface RequireAuthProps {
  children: React.ReactNode;
}

export function RequireAuth({ children }: RequireAuthProps) {
  const { state } = useAuth();
  const location = useLocation();

  if (state.status === 'unknown') {
    return (
      <div className="auth-page">
        <div className="spinner" />
      </div>
    );
  }

  if (state.status !== 'authenticated') {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}

interface RedirectIfAuthenticatedProps {
  children: React.ReactNode;
}

export function RedirectIfAuthenticated({ children }: RedirectIfAuthenticatedProps) {
  const { state } = useAuth();

  if (state.status === 'authenticated' || state.status === 'refreshing') {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
